import { Card, Link, Text } from '@nike/eds';

export const LoggedOut = () => {
  return (
    <div className="eds-flex eds-flex--align-items-center eds-flex--justify-content-center eds-spacing--mt-96">
      <Card className=''>
        <Text font='body-2'>You are logged out. Please <Link href="/">Log In</Link>.</Text>
      </Card>
    </div>
  );
};